import snakecaseKeys from 'snakecase-keys';
import { GeneralException } from '@injectivelabs/exceptions';
import { CosmwasmWasmV1Tx } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
import { fromUtf8 } from '../../../../utils/utf8.js';
/**
 * @category Messages
 */
export default class MsgMigrateContract extends MsgBase {
    static fromJSON(params) {
        return new MsgMigrateContract(params);
    }
    toProto() {
        const { params } = this;
        const message = CosmwasmWasmV1Tx.MsgMigrateContract.create();
        message.sender = params.sender;
        message.contract = params.contract;
        message.codeId = params.codeId.toString();
        message.msg = fromUtf8(JSON.stringify(params.msg));
        return CosmwasmWasmV1Tx.MsgMigrateContract.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/cosmwasm.wasm.v1.MsgMigrateContract',
            ...proto,
        };
    }
    toAmino() {
        const { params } = this;
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
            msg: params.msg,
        };
        return {
            type: 'wasm/MsgMigrateContract',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/cosmwasm.wasm.v1.MsgMigrateContract',
            ...value,
        };
    }
    toEip712() {
        throw new GeneralException(new Error('EIP712_v1 is not supported for MsgMigrateContract. Please use EIP712_v2'));
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/cosmwasm.wasm.v1.MsgMigrateContract',
            message: proto,
        };
    }
    toBinary() {
        return CosmwasmWasmV1Tx.MsgMigrateContract.encode(this.toProto()).finish();
    }
}
